module.exports = __webpack_public_path__ + "img/fun8.9b0a1c81.jpg";